import { Language } from '@/types'
import type { OptionFieldFilter } from '@/services/queries/utils/filters'
import type { OrganizationScopeKind } from '@/utils/organization'

export type OptionAudience = 'display' | 'picker' | 'moderation'

export const propertyQueryKey = (propertyId: string) =>
  ['properties', propertyId] as const

export const getOptionFilterHash = (
  optionFilter?: OptionFieldFilter,
): string => {
  if (!optionFilter) return 'no-filter'
  return JSON.stringify(optionFilter)
}

export const listQueryKey = (
  listId: string | undefined,
  lang?: Language,
  audience: OptionAudience = 'picker',
  optionFilter?: OptionFieldFilter,
) =>
  ['list', listId, lang, audience, getOptionFilterHash(optionFilter)] as const

export const listQueryPrefix = (listId: string | undefined) =>
  ['list', listId] as const

export const optionsByFieldQueryKey = (
  listId: string | undefined,
  lang?: Language,
  audience: OptionAudience = 'moderation',
  optionFilter?: OptionFieldFilter,
) =>
  [
    'optionsByField',
    listId,
    lang,
    audience,
    getOptionFilterHash(optionFilter),
  ] as const

export const optionsByFieldQueryPrefix = (listId: string | undefined) =>
  ['optionsByField', listId] as const

export type ListFieldsScopeInput = {
  scopeKind: OrganizationScopeKind
  activeOrganizationId?: string
  inheritedOrganizationIds?: readonly string[]
}

export const listsAllQueryKey = ({
  scopeKind,
  activeOrganizationId,
  inheritedOrganizationIds = [],
}: ListFieldsScopeInput) =>
  [
    'lists-all',
    scopeKind,
    activeOrganizationId,
    inheritedOrganizationIds,
  ] as const
